import { Body1, Body2 } from '@components/Texts/Texts';
import tw, { styled } from 'twin.macro';

export const ProfileFormDescriptionText = styled(Body1)<{ isExpanded: boolean }>`
  display: -webkit-box;
  box-orient: vertical;
  --moz-orient: vertical;
  -webkit-box-orient: vertical;
  ${p => !p.isExpanded && `-webkit-line-clamp: 2;`}
  ${tw`mt-2 overflow-hidden overflow-ellipsis`}
`;

export const ProfileFormDescriptionSubText = styled(Body2)`
  ${tw`cursor-pointer w-max text-brand-primary font-bold`}
`;
